import {
  Avatar,
  Box,
  FormControl,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BrowseGalleryIcon from "@mui/icons-material/BrowseGallery";
import { getAllSites } from "../../../api/newsspecs/sites/SitesSpecsAPI";
import { HighlightNumber } from "../../../components/HighlightNumber";
import { siteDetail } from "../../../api/statistics/site/SiteStatisticsAPI";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import RandomColor from "../../../util/RandomColor";
import ArticleIcon from "@mui/icons-material/Article";
import { Bar } from "react-chartjs-2";
import { horizontalChartOptions } from "../../../util/ChartStyleUtil";
import { Chart, registerables } from "chart.js";
import WordCloudWrapper from "../../../components/WordCloudWrapper";
import { averageByField } from "../../../util/ArrayUtil";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { errorNoti } from "../../../util/SnackbarMessage";
import { useSnackbar } from "notistack";
import NumberBox from "../../../components/NumberBox";
import SiteIcon from "../../../util/SiteIcon";
import { TopicIcon } from "../../../util/TopicIcon";
Chart.register(...registerables);

export function SiteSpecializationPage() {
  const [sites, setSites] = useState([]);
  const [chosenSite, setChosenSite] = useState("vnexpress");
  const [articleCountToday, setArticleCountToday] = useState(-1);
  const [averageArticleCount, setAverageArticleCount] = useState(-1);
  const [hotKeywords, setHotKeywords] = useState([]);
  const [activeAuthors, setActiveAuthors] = useState([]);
  const [activeTopics, setActiveTopics] = useState([]);
  const [authorsCount, setAuthorsCount] = useState(-1);
  const [averageHeadlineTime, setAverageHeadlineTime] = useState(-1);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(["common", "site", "error"]);

  const setDefault = () => {
    setActiveAuthors([]);
    setHotKeywords([]);
    setAuthorsCount(-1);
    setArticleCountToday(-1);
    setAverageArticleCount(-1);
    setAverageHeadlineTime(-1);
    setActiveTopics([]);
  };

  useEffect(() => {
    getAllSites()
      .then((res) => setSites(res))
      .catch(() => {});
  }, []);

  useEffect(() => {
    siteDetail(chosenSite)
      .then((res) => {
        setActiveAuthors(res["activeAuthors"] ? res["activeAuthors"] : []);
        setActiveTopics(res["activeTopics"]);
        setHotKeywords(res["hotKeywords"]);
        setAuthorsCount(res["authorsCount"] ? res["authorsCount"] : 0);
        setAverageHeadlineTime(
          res["averageHeadlinesTime"] ? res["averageHeadlinesTime"] : 0
        );
        setArticleCountToday(
          res["todayArticleCount"].length > 0
            ? res["todayArticleCount"][1][1]
            : 0
        );
        // console.log(res["weekArticlesCount"]);
        setAverageArticleCount(
          res["weekArticlesCount"].length > 0
            ? Math.floor(
                averageByField(res["weekArticlesCount"].slice(0, 6), 1)
              )
            : 0
        );
      })
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [chosenSite]);

  const topicLabels = activeTopics.map((topic) => topic[0]);
  var topicOptions = horizontalChartOptions();
  topicOptions.plugins.legend.display = false;

  var maxTopicAppearanceCounts =
    activeTopics.length > 0 ? activeTopics[0][1] : 1;
  var displayTopics = activeTopics.slice(0, 8).map((topic) => {
    console.log(topic[0]);
    return (
      <ListItem style={{ paddingBottom: "0px", paddingTop: "0px" }}>
        <ListItemAvatar>
          <Avatar style={{ background: "none" }}>
            {TopicIcon({ name: topic[0] })}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={topic[0]}
          primaryTypographyProps={{ fontSize: "14px" }}
          secondary={topic[1] + " " + t("common:articles")}
          secondaryTypographyProps={{ fontSize: "11px" }}
        ></ListItemText>
        <Box sx={{ width: "35%", marginRight: "5px" }}>
          <LinearProgress
            variant="determinate"
            color={"success"}
            value={(100 * topic[1]) / maxTopicAppearanceCounts}
          />
        </Box>
      </ListItem>
    );
  });

  let sitesUnique = [...new Set(sites)];
  const buttons = sitesUnique.map(function (site) {
    return <MenuItem value={site["name"]}>{site["name"]}</MenuItem>;
  });

  var maxAuthorArticlesCount =
    activeAuthors.length > 0 ? activeAuthors[0][1] : 1;

  console.log(sites);
  console.log(activeAuthors);

  var displayAuthors = activeAuthors.slice(0, 8).map((author) => {
    var siteData = sites.filter((a) => {
      return a["name"] == chosenSite;
    });
    var siteIcon = SiteIcon(siteData[0]["domain"]);
    return (
      <ListItem style={{ paddingBottom: "0px", paddingTop: "0px" }}>
        <ListItemAvatar>
          <Avatar alt={chosenSite} src={siteIcon} />
        </ListItemAvatar>
        <ListItemText
          primaryTypographyProps={{ fontSize: "14px" }}
          primary={author[0]}
          secondary={author[1] + " " + t("common:articles")}
          secondaryTypographyProps={{ fontSize: "11px" }}
        ></ListItemText>
        <Box sx={{ width: "35%", marginRight: "5px" }}>
          <LinearProgress
            variant="determinate"
            color={"info"}
            value={(100 * author[1]) / maxAuthorArticlesCount}
          />
        </Box>
      </ListItem>
    );
  });

  return (
    <Grid container spacing={2} textAlign={"center"}>
      <Grid item xs={0.75}></Grid>
      <Grid
        item
        xs={10.5}
        textAlign={"left"}
        className=""
        style={{ marginBottom: "20px" }}
      >
        <Typography variant="h5" fontWeight={600}>
          {t("site:dashboard_for_site")}{" "}
          {
            <FormControl
              fullWidth
              style={{ height: "35px", display: "inline", zIndex: "500000" }}
              id="topic-form-control"
            >
              <Select
                value={chosenSite}
                label=""
                onChange={(event: SelectChangeEvent) => {
                  setDefault();
                  setChosenSite(event.target.value as string);
                }}
                style={{
                  width: "220px !important",
                  fontSize: "22px",
                  fontWeight: 500,
                  height: "35px",
                  marginLeft: "10px",
                  paddingBottom: "1px",
                  zIndex: "500000000",
                }}
                MenuProps={{
                  sx: {
                    marginTop: "40px",
                  },
                }}
              >
                {buttons}
              </Select>
            </FormControl>
          }{" "}
        </Typography>
      </Grid>
      <Grid item xs={0.75}></Grid>
      <Grid container>
        <Grid item xs={0.75}></Grid>
        <Grid
          item
          xs={2.25}
          padding={2}
          className="grid-border white slide-from-left"
          textAlign={"center"}
        >
          <NumberBox
            title={t("site:articles_count_today")}
            number={articleCountToday}
            variant={"h3"}
            icon={
              <ArticleIcon
                sx={{ width: "40px", height: "40px", color: "#81d4fa" }}
              />
            }
            subtitle={t("common:derived_from_today")}
          ></NumberBox>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid
          item
          xs={2.2}
          padding={2}
          className="grid-border white slide-from-left"
        >
          <NumberBox
            title={t("site:average_articles_count")}
            number={averageArticleCount}
            variant={"h3"}
            icon={
              <ContentCopyIcon
                color="disabled"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid
          item
          xs={2.6}
          padding={2}
          className="grid-border white slide-from-right"
        >
          <NumberBox
            title={t("keyword:average_headline_time")}
            variant={"h3"}
            number={Math.round(averageHeadlineTime) + " " + t("common:minutes")}
            icon={
              <BrowseGalleryIcon
                sx={{ width: "40px", height: "40px", color: "#81d4fa" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid
          item
          xs={2.2}
          padding={2}
          className="grid-border white slide-from-right"
        >
          <NumberBox
            title={t("site:authors_count")}
            variant={"h3"}
            number={authorsCount}
            icon={
              <ContactMailIcon
                sx={{ width: "40px", height: "40px", color: "green" }}
              />
            }
            subtitle={t("common:derived_from_this_month")}
          />
        </Grid>
        <Grid item xs={0.5}></Grid>
      </Grid>

      <Grid container marginTop={5}>
        <Grid item xs={0.75}></Grid>
        <Grid
          item
          xs={3.25}
          padding={2}
          className="grid-border white slide-from-left"
        >
          <Typography variant="h6" fontWeight={600}>
            {t("site:top_10_authors")}
          </Typography>
          <List>{displayAuthors}</List>
        </Grid>
        <Grid item xs={0.375}></Grid>
        <Grid
          item
          xs={3.5}
          padding={2}
          className="grid-border white slide-from-bottom"
        >
          <Typography variant="h6" fontWeight={600}>
            {t("site:popular_keywords")}
          </Typography>
          <WordCloudWrapper
            words={hotKeywords}
            time={2}
            noTable={true}
          ></WordCloudWrapper>
        </Grid>
        <Grid item xs={0.375}></Grid>
        <Grid
          item
          xs={3.25}
          padding={2}
          className="grid-border white slide-from-right"
        >
          <Typography variant="h6" fontWeight={600}>
            {t("site:active_topics")}
          </Typography>
          <List>{displayTopics}</List>
        </Grid>
        <Grid item xs={0.25}></Grid>
      </Grid>
    </Grid>
  );
}
